<template>
  <v-container fluid>
    <v-row justify="space-between">
      <v-col cols="12" md="12">
        <div class="float-right parent fixed btn">
          <v-btn
            width="150"
            depressed
            large
            color="primary"
            v-on:saved="dialog = false"
            @click="$emit('save')"
            >Save</v-btn
          >
        </div>
      </v-col>
      <v-col cols="12" sm="10" md="6">
        <v-tabs-items
          :class="{ 'light-background-color': isOnBoarding }"
          v-model="tab"
          align-center
          justify-center
        >
          <v-form>
            <v-tab-item>
              <!-- Tab 1 - Card Front -->
              <p class="text-subtitle-1 font-weight-medium mb-2">Logo frame</p>

              <div class="d-flex">
                <div class="d-flex justify-start mb-2 logo-frame-container">
                  <div class="d-flex justify-center">
                    <div
                      :class="[
                        { selected: logo_frame == 'logo-frame-circle' },
                        'circle cursor-pointer grey-filled mr-8',
                      ]"
                      style="width: 60px; height: 60px"
                      v-ripple="{ center: true, class: 'rounded-circle' }"
                      @click="logo_frame = 'logo-frame-circle'"
                    ></div>
                    <div
                      v-bind:class="[
                        { selected: logo_frame == 'logo-frame-square' },
                        'cursor-pointer grey-filled  mr-8 rounded-lg',
                      ]"
                      style="width: 60px; height: 60px"
                      v-ripple="{ center: true }"
                      @click="logo_frame = 'logo-frame-square'"
                    ></div>
                    <div
                      :class="[
                        { selected: logo_frame == 'logo-frame-rectangle' },
                        'cursor-pointer  grey-filled mr-8 rounded-lg ',
                      ]"
                      style="width: 120px; height: 60px"
                      v-ripple="{ center: true }"
                      @click="logo_frame = 'logo-frame-rectangle'"
                    ></div>
                  </div>
                </div>
              </div>

              <p class="text-subtitle-1 font-weight-medium mb-2 mt-5">Logo</p>

              <v-row>
                <v-col md="3">
                  <div
                    class="
                      d-flex
                      justify-center
                      align-center
                      cursor-pointer
                      outlined-border
                      rounded-lg
                    "
                    style="width: 100%; height: 100%"
                    v-ripple="false"
                    @click="uploadImageDialog = true"
                  >
                    <div
                      class="
                        grey--text
                        font-weight-bold
                        cursor-pointer
                        text-center
                      "
                    >
                      + Add new image
                    </div>
                  </div>

                  <UploadImageDialog
                    previewType="logoImageURL"
                    :selectedlogoFrame="logo_frame"
                    :show="uploadImageDialog"
                    @close="uploadImageDialog = false"
                    @uploaded="handleUploaded"
                    :businessCardRotatorObject="businessProfile"
                    :image="editImageURL"
                    ref="uploadImageDialog"
                  />
                </v-col>
                <v-col
                  v-for="(image, index) in imageList"
                  :key="`logoImageURL${index}`"
                  md="3"
                >
                  <v-hover v-slot="{ hover }">
                    <v-sheet
                      :class="
                        logo_image_url == image ? 'selected' : 'border-default'
                      "
                      width="100%"
                      height="100%"
                      rounded="lg"
                      @click="logo_image_url = image"
                    >
                      <v-img
                        :src="image"
                        :aspect-ratio="1"
                        rounded="lg"
                        style="border-radius: 7px !important"
                      >
                        <div
                          class="text-right mt-2 mr-2"
                          v-show="
                            hover &&
                            !defaultImages.includes(image) &&
                            !(logo_image_url == image)
                          "
                        >
                          <v-btn
                            :key="`edit${index}`"
                            @click.stop="handleEdit(image, 'logoImageURL')"
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn
                            :key="`delete${index}`"
                            @click.stop="handleDelete(image)"
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-trash-can
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-img>
                    </v-sheet>
                  </v-hover>
                </v-col>
              </v-row>
              <!--End:New Designs-->
            </v-tab-item>
            <v-tab-item>
              <!-- Tab 2 - Card Back -->

              <!--New Designs-->
              <p class="text-subtitle-1 font-weight-medium mt-5 mb-2">
                Select or upload a branded image
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-2" size="22">
                      help_outline
                    </v-icon>
                  </template>
                  <span>
                    Add a photo or vector design.<br />
                    We recommend an image with an aspect ratio of
                    <b>3 : 2</b>.<br />
                    Maximum file size: <b>2MB</b><br />
                    Allowed file extensions: <b>.jpeg, .jpg, .png</b>
                  </span>
                </v-tooltip>
              </p>

              <v-row>
                <v-col md="4">
                  <div
                    class="
                      fab
                      d-flex
                      justify-center
                      align-center
                      cursor-pointer
                      outlined-border
                      rounded-lg
                    "
                    style="height: 100%; width: 100%"
                    v-ripple="false"
                    @click="uploadReverseImageDialog = true"
                  >
                    <div
                      class="
                        grey--text
                        font-weight-bold
                        cursor-pointer
                        text-center
                      "
                    >
                      + Add new image
                    </div>
                  </div>

                  <UploadImageDialog
                    previewType="reverseImageURL"
                    :show="uploadReverseImageDialog"
                    @close="uploadReverseImageDialog = false"
                    @uploaded="handleUploaded"
                    :businessCardRotatorObject="businessProfile"
                    :image="editImageURL"
                    ref="uploadReverseImageDialog"
                  />
                </v-col>

                <v-col
                  v-for="(image, index) in imageList"
                  :key="`reverseImage${index}`"
                  md="4"
                >
                  <v-hover v-slot="{ hover }">
                    <v-sheet
                      :class="
                        reverse_image_url == image
                          ? 'selected'
                          : 'border-default'
                      "
                      width="100%"
                      height="100%"
                      rounded="lg"
                      @click="reverse_image_url = image"
                    >
                      <v-img
                        :src="image"
                        :aspect-ratio="1.512"
                        rounded="lg"
                        style="border-radius: 7px !important"
                      >
                        <div
                          class="text-right mt-2 mr-2"
                          v-show="
                            hover &&
                            !defaultImages.includes(image) &&
                            !(reverse_image_url == image)
                          "
                        >
                          <v-btn
                            :key="`edit${index}`"
                            @click.stop="handleEdit(image, 'reverseImageURL')"
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn
                            :key="`delete${index}`"
                            @click.stop="handleDelete(image)"
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-trash-can
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-img>
                    </v-sheet>
                  </v-hover>
                </v-col>
              </v-row>
              <!--End:New Designs-->
            </v-tab-item>
            <v-tab-item>
              <!-- Tab 3 - Background -->
              <p class="text-subtitle-1 font-weight-medium mt-5 mb-2">
                Select or upload a branded image
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-2" size="22">
                      help_outline
                    </v-icon>
                  </template>
                  <span>
                    Add a photo or vector design.<br />
                    We recommend an image with an aspect ratio of
                    <b>3 : 2</b>.<br />
                    Maximum file size: <b>2MB</b><br />
                    Allowed file extensions: <b>.jpeg, .jpg, .png</b>
                  </span>
                </v-tooltip>
              </p>

              <v-row>
                <v-col md="4">
                  <div
                    class="
                      fab
                      d-flex
                      justify-center
                      align-center
                      cursor-pointer
                      outlined-border
                      rounded-lg
                    "
                    style="width: 100%; height: 100%"
                    @click="uploadBackgroundImageDialog = true"
                  >
                    <div
                      class="
                        grey--text
                        font-weight-bold
                        cursor-pointer
                        text-center
                      "
                    >
                      + Add new image
                    </div>
                  </div>
                  <UploadImageDialog
                    previewType="backgroundImageURL"
                    :show="uploadBackgroundImageDialog"
                    @close="uploadBackgroundImageDialog = false"
                    @uploaded="handleUploaded"
                    :businessCardRotatorObject="businessProfile"
                    :image="editImageURL"
                    ref="uploadBackgroundImageDialog"
                  />
                </v-col>

                <v-col
                  v-for="(image, index) in imageList"
                  :key="`backgroundImage${index}`"
                  md="4"
                >
                  <v-hover v-slot="{ hover }">
                    <v-sheet
                      :class="
                        background_image_url == image
                          ? 'selected'
                          : 'border-default'
                      "
                      width="100%"
                      height="100%"
                      rounded="lg"
                      @click="background_image_url = image"
                    >
                      <v-img
                        :src="image"
                        :aspect-ratio="1.512"
                        rounded="lg"
                        style="border-radius: 7px !important"
                      >
                        <div
                          class="text-right mt-2 mr-2"
                          v-show="
                            hover &&
                            !defaultImages.includes(image) &&
                            !(background_image_url == image)
                          "
                        >
                          <v-btn
                            :key="`edit${index}`"
                            @click.stop="
                              handleEdit(image, 'backgroundImageURL')
                            "
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn
                            :key="`delete${index}`"
                            @click.stop="handleDelete(image)"
                            fab
                            x-small
                            color="white"
                            class="mr-1"
                          >
                            <v-icon
                              :class="{ 'show-btns': hover }"
                              color="secondary"
                            >
                              mdi-trash-can
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-img>
                    </v-sheet>
                  </v-hover>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-form>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" md="6">
        <v-row align="center" justify="flex-end" no-gutters>
          <v-col cols="12" sm="12">
            <BusinessCardRotator
              :cardCorners="card_corners"
              :logoFrame="logo_frame"
              :logoImageURL="logo_image_url"
              :reverseImageURL="reverse_image_url"
              :backgroundImageURL="background_image_url"
              :hideToggleControl="tab != 2 ? true : false"
              :businessCardSideProp="tab"
              :showBackground="tab == 2 ? true : false"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BusinessCardRotator from "./BusinessCardRotator";
import { mapGetters, mapActions } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
let uuid = require("uuid");
import UploadImageDialog from "@/components/UploadImageDialog";
import {getDownloadUrlForRef, getStorageRef, uploadFileInStorage} from "@/shared/firebase_utils";
import { TaskState } from "firebase/storage";

export default {
  name: "BusinessCardEditor",
  components: {
    BusinessCardRotator,
    vueDropzone: vue2Dropzone,
    UploadImageDialog,
  },
  data() {
    return {
      logo_frame: "",
      logo_image_url: "",
      reverse_image_url: "",
      background_image_url: "",
      card_corners: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 10,
        thumbnailHeight: 10,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      logoImageUploadProgress: 100,
      isLogoImageUploadCancelled: false,
      logoThumbnail: "",
      reverseImageUploadProgress: 100,
      isReverseImageUploadCancelled: false,
      reverseImageThumbnail: "",
      backgroundImageUploadProgress: 100,
      isBackgroundImageUploadCancelled: false,
      backgroundImageThumbnail: "",
      uploadImageDialog: false,
      uploadReverseImageDialog: false,
      uploadBackgroundImageDialog: false,
      defaultImages: [
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_1.png?alt=media&token=eaaa4308-db9d-4b4d-9ad4-828ac7454ab7",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_2.png?alt=media&token=e2112092-7b35-4a75-987f-dd542ce8b9e2",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_3.png?alt=media&token=30456377-366c-4a8d-aaeb-2c3db9568210",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_4.png?alt=media&token=c9111f1a-c150-4847-b2ef-2fb657d1beff",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_5.png?alt=media&token=fd78d284-470e-4bd6-9b7e-cb7ebad926f0",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_6.png?alt=media&token=2f55f010-cbec-4d89-9058-9f43a397a7bb",
      ],
      editImageURL: "",
    };
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    isOnBoarding: {
      type: Boolean,
      default: false,
    },
    bus: {},
  },
  computed: {
    ...mapGetters(["businessProfile"]),
    imageList() {
      //Show selected reverse image at start of image list
      if (this.tab == 1)
        return this.getImageListBasedOnType(
          this.businessProfile.reverseImageURL
        );
      else if (this.tab == 2)
        return this.getImageListBasedOnType(
          this.businessProfile.backgroundImageURL
        );
      else
        return this.getImageListBasedOnType(this.businessProfile.logoImageURL);
    },
  },

  mounted() {
    this.bus.$on("initEditor", this.initEditor);
    this.initEditor();

    //Initialize imageURLs array for existing business profiles.
    if (this.businessProfile.imageURLs == undefined)
      this.businessProfile.imageURLs = [];
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),
    initEditor() {
      this.logo_frame = this.businessProfile.logoFrame || "logo-frame-circle";

      this.logo_image_url = this.businessProfile.logoImageURL || "";

      this.reverse_image_url = this.businessProfile.reverseImageURL || "";
      this.background_image_url = this.businessProfile.backgroundImageURL || "";
      this.card_corners =
        this.businessProfile.cardCorners || "card-corners-curved";
    },
    async onSave() {
      try {
        this.updateBusinessProfileDetails({
          logoFrame: this.logo_frame,
          logoImageURL: this.logo_image_url,
          reverseImageURL: this.reverse_image_url,
          backgroundImageURL: this.background_image_url,
          cardCorners: this.card_corners,
        });
      } catch (error) {
        console.log("Error updating the business card details" + error);
      }
    },

    async logoImageAdded(file) {
      try {
        this.$refs.logoImageDropzone.removeAllFiles();
        this.isLogoImageUploadCancelled = false;

        //Get a unique file name and set the meta data for the file
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };

        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);
        this.logoImageUploadProgress = 0;
        var uploadTask = uploadFileInStorage(file, metaData);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.logoImageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (this.logoImageUploadProgress == 100)
                  this.logo_image_url = "";
                if (this.isLogoImageUploadCancelled) {
                  uploadTask.cancel();
                  this.logoImageUploadProgress = 100;
                  console.log("Image upload cancelled");
                }
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            getDownloadUrlForRef(uploadTask.snapshot.ref).then((downloadURL) => {
              this.logo_image_url = downloadURL;
            });
          }
        );
      } catch (error) {
        console.log("Error while uploading an image");
        console.log(error);
      }
    },

    async reverseImageAdded(file) {
      try {
        this.$refs.reverseImageDropzone.removeAllFiles();
        this.isReverseImageUploadCancelled = false;

        //Get a unique file name and set the meta data for the file
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };

        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);
        this.reverseImageUploadProgress = 0;
        var uploadTask = uploadFileInStorage(imageRef, file, metaData);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.reverseImageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (this.reverseImageUploadProgress == 100)
                  this.reverse_image_url = "";
                if (this.isReverseImageUploadCancelled) {
                  uploadTask.cancel();
                  this.reverseImageUploadProgress = 100;
                  console.log("Image upload cancelled");
                }
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            getDownloadUrlForRef(uploadTask.snapshot.ref).then((downloadURL) => {
              this.reverse_image_url = downloadURL;
            });
          }
        );
      } catch (error) {
        console.log("Error while uploading the reverse image");
        console.log(error);
      }
    },

    async backgroundImageAdded(file) {
      try {
        this.$refs.backgroundImageDropzone.removeAllFiles();
        this.isBackgroundImageUploadCancelled = false;

        //Get a unique file name and set the meta data for the file
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };

        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);

        this.backgroundImageUploadProgress = 0;
        var uploadTask = (imageRef, file, metaData);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.backgroundImageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (this.backgroundImageUploadProgress == 100)
                  this.background_image_url = "";
                if (this.isBackgroundImageUploadCancelled) {
                  uploadTask.cancel();
                  this.backgroundImageUploadProgress = 100;
                  console.log("Background Image upload cancelled");
                }
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.background_image_url = downloadURL;
            });
          }
        );
      } catch (error) {
        console.log("Error while uploading the reverse image");
        console.log(error);
      }
    },

    attachLogoThumbnail(file, dataUrl) {
      this.logoThumbnail = dataUrl;
    },
    attachReverseImageThumbnail(file, dataUrl) {
      this.reverseImageThumbnail = dataUrl;
    },
    attachBackgroundImageThumbnail(file, dataUrl) {
      this.backgroundImageThumbnail = dataUrl;
    },
    handleUploaded(downloadURL, imageType, logoFrame) {
      if (imageType == "logoImageURL") {
        this.logo_image_url = downloadURL;
        this.uploadImageDialog = false;
        this.logo_frame = logoFrame;
      }

      if (imageType == "reverseImageURL") {
        this.reverse_image_url = downloadURL;
        this.uploadReverseImageDialog = false;
      }

      if (imageType == "backgroundImageURL") {
        this.background_image_url = downloadURL;
        this.uploadBackgroundImageDialog = false;
      }
    },

    getImageListBasedOnType(selectedImage) {
      let imageList = [];

      if (selectedImage != "" && selectedImage != undefined) {
        //Push all default images to imageList except selectedImage
        imageList = this.defaultImages.filter((imageURL) => {
          return imageURL != selectedImage;
        });

        //Add selected image at index 0
        imageList.unshift(selectedImage);
      } else imageList = [...this.defaultImages];

      if (
        this.businessProfile.imageURLs?.length != 0 &&
        this.businessProfile.imageURLs != undefined
      ) {
        //If selectedImage is not "", show it at start of imageList
        let insertAtIndex = imageList.indexOf(selectedImage) == -1 ? 0 : 1;

        //Insert images uploaded by user.
        imageList.splice(
          insertAtIndex,
          0,
          ...this.businessProfile.imageURLs?.filter((imageURL) => {
            return imageURL != selectedImage;
          })
        );
      }

      return imageList;
    },

    async handleEdit(image, imageType) {
      this.editImageURL = image;
      this.imageType = imageType;

      //Fetch the image from url, convert to blob
      let res = await fetch(image);
      let blob = await res.blob();

      if (imageType == "logoImageURL") {
        this.$refs.uploadImageDialog.fileAdded(blob);
        this.uploadImageDialog = true;
      } else if (imageType == "reverseImageURL") {
        this.$refs.uploadReverseImageDialog.fileAdded(blob);
        this.uploadReverseImageDialog = true;
      } else {
        this.$refs.uploadBackgroundImageDialog.fileAdded(blob);
        this.uploadBackgroundImageDialog = true;
      }

      console.log("uploadReverseImageDialog: ", this.uploadReverseImageDialog);
      console.log("uploadImageDialog: ", this.uploadImageDialog);
    },

    async handleDelete(imageURL) {
      try {
        this.businessProfile.imageURLs = this.businessProfile.imageURLs.filter(
          (image) => {
            return image != imageURL;
          }
        );

        await this.updateBusinessProfileDetails({
          imageURLs: this.businessProfile?.imageURLs,
        });
        this.showSnackbar({ show: true, text: "Deleted successfully!" });
      } catch (err) {
        console.log("Error occurred while deleting an uploaded image: ", err);
        this.showSnackbar({
          show: true,
          text: "Could not delete image, please try again!",
        });
      }
    },
  },
};
</script>
<style>
.dz-image img {
  width: 100%;
  height: 100%;
}
.dropzone {
  min-height: 64px;
  height: 64px;
  border-radius: 4px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.light-background-color {
  background-color: #f6f6f6 !important;
}
.selected {
  outline: 3px solid #f15f31;
  outline-offset: 3px;
}
.cursor-pointer {
  cursor: pointer !important;
}
.border-default {
  border: 1px solid #e0e0e0 !important;
}

.circle {
  border-radius: 50%;
}

.logo-frame-container .grey-filled {
  background-color: #e0e0e0;
}

.outlined-border {
  border: 1px solid #e0e0e0;
}
</style>
